export const popoverPickerTriggerClass =
  'flex h-11 w-full items-center justify-between rounded-none border border-input bg-background px-4 py-3 text-left text-base ring-offset-background transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';

export const popoverPickerContentClass =
  'z-[60] w-[var(--radix-popover-trigger-width)] max-h-[min(24rem,var(--radix-popover-content-available-height))] overflow-hidden rounded-none border bg-popover p-1 text-popover-foreground shadow-none';

export const popoverPickerListClass =
  'max-h-[min(14rem,calc(var(--radix-popover-content-available-height)-4.5rem))] overflow-y-auto';

export const popoverPickerSearchListClass =
  'max-h-[min(12rem,calc(var(--radix-popover-content-available-height)-5.5rem))] overflow-y-auto border-t border-border pt-1';
